import {Component, Input, OnInit} from '@angular/core';
import {FormBuilder} from '@angular/forms';
import {AuthService} from '../../../../autenticacion/servicios/auth.service';
import {ConsumerService} from '../../../recursos/servicio/consumer.service';
import {UtilConfig} from '../../../../autenticacion/servicios/UtilConfig';
import {Router} from '@angular/router';
import {WebServices} from '../../../recursos/modelo/consumerModel/web-services.enum';
import {BsDatepickerConfig} from 'ngx-bootstrap/datepicker';
import {leftPad} from '../../../../../pipes/utils/utils';

declare var $: any;
declare var swal: any;

@Component({
    selector: 'app-emisor-facturas',
    templateUrl: './view/emisor-facturas.component.html',
    styleUrls: ['./css/emisor-facturas.component.scss'],
    providers: [AuthService]
})
export class EmisorFacturasComponent implements OnInit {

    @Input() documento;
    @Input() popup = false;
    loadingConsultas = [
        {
            modulo: 'Buscando documento',
            cargando: false
        }
    ];

    ndPenalidades = false;
    loading = false;
    itemLista: any[];
    documentType: any[];
    mensaje = '';
    error = false;
    serie: String;
    tipo: any;
    nota: any;
    @Input() tipoDoc = '01';
    usuarioSession: any;
    rangeDates: Date = new Date();

    filtroList = {
        consecutivo: '',
        document: 'INVOICE',
        numeroSerie: ''
    };
    colorTheme = 'theme-dark-blue';
    bsConfig: Partial<BsDatepickerConfig> = Object.assign({}, {
        containerClass: this.colorTheme,
        showWeekNumbers: false,
        dateInputFormat: 'DD/MM/YYYY'
    });

    authorities = {
        ROLE_FACTURADOR_INVOICE: false,
        ROLE_FACTURADOR_TICKET: false,
        ROLE_FACTURADOR_NC: false,
        ROLE_FACTURADOR_ND: false,
        ROLE_FACTURADOR_GRE: false,
        ROLE_FACTURADOR_ANULACIONES: false,
        ROLE_FACTURADOR_RETENCIONES: false
    };

    constructor(private util: UtilConfig,
                private fb: FormBuilder,
                private router: Router,
                private consumer: ConsumerService) {
        this.usuarioSession = this.util.getCurrentUser();

        // VERIFICA LOS PERMISOS DEL USUARIO LOGEADO
        this.authorities = this.util.verificarAuthorities(this.authorities);
        this.displayPrimaryOperation();

        this.documentType = [];
        this.documentType.push({label: 'FACTURA', value: 'INVOICE'});
        this.documentType.push({label: 'BOLETA', value: 'TICKET'});
        this.documentType.push({label: 'RETENCION', value: 'RETENTION'});
    }

    ngOnInit(): void {
        if (this.popup === null) {
            this.popup = false;
        }
    }

    displayPrimaryOperation() {
        if (this.authorities.ROLE_FACTURADOR_INVOICE) {
            this.tipoDoc = '01';
            return false;
        }
        if (this.authorities.ROLE_FACTURADOR_TICKET) {
            this.tipoDoc = '03';
            return false;
        }
        if (this.authorities.ROLE_FACTURADOR_NC) {
            this.tipoDoc = '07';
            return false;
        }
        if (this.authorities.ROLE_FACTURADOR_ND) {
            this.tipoDoc = '08';
            return false;
        }
        if (this.authorities.ROLE_FACTURADOR_GRE) {
            this.tipoDoc = '09';
            return false;
        }
        if (this.authorities.ROLE_FACTURADOR_ANULACIONES) {
            this.tipoDoc = 'RA';
            return false;
        }
        if (this.authorities.ROLE_FACTURADOR_RETENCIONES) {
            this.tipoDoc = '20';
            return false;
        }
    }

    asignarDocumentoFiltro(value: string) {
        this.filtroList.document = value;
    }

    private realizarBusqueda() {
        this.loadingConsultas[0].cargando = true;
        const params = {
            rucEmisor: this.usuarioSession.customer.ruc,
            status: 'ACEPTADAS',
            statusCPE: 'ACTIVO',
            tipoFecha: 'EMISION',
            fechaDesde: this.rangeDates,
            fechaHasta: this.rangeDates,
            consecutivoMin: (this.filtroList.consecutivo === '') ? null : this.filtroList.consecutivo,
            consecutivoMax: (this.filtroList.consecutivo === '') ? null : this.filtroList.consecutivo,
            documentType: this.filtroList.document,
            numeroSerie: (this.filtroList.numeroSerie === '') ? null : this.filtroList.numeroSerie.toLocaleUpperCase()
        };
        this.consumer.post<any>(WebServices.URL_LIST_LOG_EMISOR, params)
            .subscribe(result => {
                this.itemLista = result['logs'];
                if ((this.itemLista != null) && (this.itemLista.length === 0)) {
                    this.loadingConsultas[0].cargando = false;
                    this.documento = null;
                    this.mensaje = '<i class=\'material-icons\'>youtube_searched_for</i> ' +
                        'UTILICE OTRO FILTRO DE BÚSQUEDA, NO SE HAN CONSEGUIDO REGISTROS';
                } else {
                    this.consumer.getById<any>('log', this.itemLista[0].id, WebServices.URL_GET_LOG_EMISOR)
                        .subscribe(result2 => {
                            this.loadingConsultas[0].cargando = false;
                            this.documento = result2['log'];
                            this.mensaje = null;
                            this.documento.fileName = this.documento.fileName.replace('.zip', '');
                        }, err => {
                            this.documento = null;
                            this.mensaje = null;
                            this.loadingConsultas[0].cargando = false;
                            this.util.abrirModalErrorParaServicios(err, 'No se pudo consultar el documento', this.router);
                        });
                }
            }, err => {
                this.documento = null;
                this.mensaje = null;
                this.loadingConsultas[0].cargando = false;
                this.itemLista = [];
                this.util.abrirModalErrorParaServicios(err, 'No se pudo consultar el documento', this.router);
            });
    }

    datosReceptor() {
        return ($('#datos_clientes_facturacion').attr('class') !== 'mat-card opacar');
    }

    datosDetalle() {
        return ($('#detalle_documento_facturacion').attr('class') !== 'mat-card opacar');
    }

    setLeftPadCorrelative() {
        this.filtroList.consecutivo = leftPad(this.filtroList.consecutivo, 8, '0');
    }

    ndPenalidadesShow(){
        this.ndPenalidades = true;
    }

}



// WEBPACK FOOTER //
// C:/Users/Natalia.Morales/IdeaProjects/datagate/administrator/frontend/src/main/webapp/src/app/layout/content/emisorFacturas/emisorFacturas/emisor-facturas.component.ts